import FullLoading from '../../../../CompUtils/FullLoading';
import { useCallback, useEffect, useMemo } from 'react';
import { Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  cleanCV,
  cleanState,
  getComiteMiembrosPublico,
  getCVPublico,
  useComite,
} from '../../../../../appStore/comite';
import { useConcurso } from '../../../../../providers/ConcursoProvider';
import { CommonRoot } from '../../../../CompUtils/CommonRoot';
import { FileModal } from '../../../../CompUtils/FileModal';
import { fetchRolComitePublico, rolComitePublicoSelector } from '../../gestionConcursoSlice';
import { ComiteHeader } from './ComiteHeader';
import { ComiteRow, RolComite } from './ComiteRowPublico';

type Props = { notCC?: boolean };

const ComiteTablePublico = (props: Props) => {
  //#region Props
  const { notCC } = props;
  //#endregion

  //#region Hooks and Redux Setup
  const { idLlamadoConcurso } = useConcurso();
  const dispatch = useDispatch();
  const { miembros, loading, file } = useComite();
  const roles = useSelector(rolComitePublicoSelector);
  //#endregion

  //#region Memoized Roles
  const finalRoles = useMemo<RolComite[]>(() => Object.keys(roles).map((r) => roles[r]), [roles]);
  //#endregion

  //#region Render Functions
  const renderComite = useCallback(() => {
    const renderHeaderRow = (text: string) => (
      <tr>
        <td
          colSpan={3}
          style={{
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#fff',
            backgroundColor: '#333',
          }}>
          {text}
        </td>
      </tr>
    );

    const miembrosComite = (miembros || []).filter((m) => m.comite_rol < 5);
    const miembrosCoordinador = (miembros || []).filter((m) => m.comite_rol === 5);

    const titularesComite = miembrosComite.filter((m) => m.titular);
    const alternosComite = miembrosComite.filter((m) => !m.titular);

    const titularesCoordinador = miembrosCoordinador.filter((m) => m.titular);
    const alternosCoordinador = miembrosCoordinador.filter((m) => !m.titular);

    // Función para renderizar filas de miembros, con la columna Designación solo en la primera fila
    const renderMiembrosRows = (
      miembrosList: typeof miembros,
      designacion: 'Titular' | 'Titulares' | 'Alterno' | 'Alternos',
    ) =>
      miembrosList?.map((m, i) => (
        <tr key={m.cuil}>
          {i === 0 && (
            <td
              rowSpan={miembrosList.length}
              style={{
                textAlign: 'center',
                verticalAlign: 'middle',
                fontWeight: 'bold',
              }}>
              {designacion}
            </td>
          )}
          <td>{`${m.apellido}, ${m.nombre}`}</td>
          <td>
            <button
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              onClick={() => dispatch(getCVPublico(m))}
              title="Ver CV público">
              <i className="fa fa-file-pdf-o" />
            </button>
          </td>
        </tr>
      ));

    return (
      <>
        {renderHeaderRow('Comité')}
        {renderMiembrosRows(titularesComite, 'Titulares')}
        {renderMiembrosRows(alternosComite, 'Alternos')}

        {renderHeaderRow('Coordinador Concursal')}
        {renderMiembrosRows(titularesCoordinador, 'Titular')}
        {renderMiembrosRows(alternosCoordinador, 'Alterno')}
      </>
    );
  }, [miembros, dispatch]);
  //#endregion

  //#region Effects
  useEffect(() => {
    dispatch(getComiteMiembrosPublico({ idLlamadoConcurso }));
    dispatch(fetchRolComitePublico());

    return () => {
      dispatch(cleanState());
    };
  }, [dispatch, idLlamadoConcurso]);
  //#endregion

  //#region JSX Return
  return (
    <CommonRoot>
      <Table bordered hover>
        <thead>
          <tr className="text-center">
            <th>Designación</th>
            <th>Nombre</th>
            <th>CV</th>
          </tr>
        </thead>
        <tbody>{renderComite()}</tbody>
      </Table>

      <FileModal file={file} onClose={() => dispatch(cleanCV())} title="CV" />

      <FullLoading show={loading} />
    </CommonRoot>
  );
  //#endregion
};

export default ComiteTablePublico;
